import React, {memo, Suspense} from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"
import {removeDeptFromSessionStorage} from "../../utils/removeDeptFromSessionStorage"

export type MiniShoppingBagCheckoutProps = {
    enable: boolean
    text: string
    url: string
    dataGaV1?: string
    dataGaV2?: string
    dataGaV3?: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const MiniShoppingBagCheckout = memo<MiniShoppingBagCheckoutProps>(function MiniShoppingBagCheckoutMemo({
    templating,
    enable,
    ...props
}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName>
                <CTA
                    {...props}
                    color="primary"
                    disabled={!enable}
                    state={enable ? "enabled" : "disabled"}
                    variant="contained"
                    size="medium"
                    dataGaV1={props.dataGaV1}
                    dataGaV2={props.dataGaV2}
                    dataGaV3={props.dataGaV3}
                    rel="nofollow"
                    onClick={removeDeptFromSessionStorage}
                />
            </ComponentName>
        </Suspense>
    )
})
MiniShoppingBagCheckout.displayName = "MiniShoppingBagCheckout"

export default connect(MiniShoppingBagCheckout)
